import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_professional_body_hdr_RowClass} from '../../../dbschema';

export class ProfessionalBodyContainerModel extends BaseContainerModel {
  bl_aat_professional_body_hdr: bl_aat_professional_body_hdr_RowClass = new bl_aat_professional_body_hdr_RowClass();
}
